import React from 'react';
import Link from 'gatsby-link';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import assets from 'marketing-website/configs/pages/enterprise/assets';
import ArrowLink from 'marketing-website/components/commons/ArrowLink';

import SecurityCard from './SecurityCard.js';

import styles from './style/security.module.css';

export default function Security() {
  return (
    <div className={styles.main}>
      <div className={styles.wrap}>
        <Spacing size="m" type="padding" position="bottom">
          <MaxWidth value={620}>
            <Heading tag="h2" weight="bold" size="xxxxl" color="black">
              Your security and compliance needs covered
            </Heading>
          </MaxWidth>
        </Spacing>
        <Spacing size="xl" type="padding" position="bottom">
          <MaxWidth value={550}>
            <Paragraph size="l">
              Marvel Enterprise provides above industry standard security to
              protect your work and data. We are EU hosted, GDPR compliant and
              provide enhanced protection features such as Single Sign-On and
              access locks to secure projects.
            </Paragraph>
          </MaxWidth>
          <Spacing size="m" type="margin" position="top">
            <Link to="/security">
              <ArrowLink size="l" weight="semibold">
                Read more about Security
              </ArrowLink>
            </Link>
          </Spacing>
        </Spacing>

        <Grid columns={3} alignItems="flex-end" size="l">
          <GridItem columnSpan={3} columnSpanL={1}>
            <SecurityCard
              title="Activity log exports"
              subtitle="Keep an offline record of Marvel activity so you can refer back to it any time you need to"
              color="yellow--l"
              image={assets.logoLog}
              raised
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanL={1}>
            <SecurityCard
              title="GDPR compliant"
              subtitle="We're committed to meeting our legal obligation and protecting the data rights of our customers"
              color="purple"
              image={assets.logoEU}
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanL={1}>
            <SecurityCard
              title="SAML-based SSO"
              subtitle="Marvel Enterprise gives your business several layers of security to their accounts"
              color="orange--l"
              image={assets.logoSaml}
              raised
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanL={1}>
            <SecurityCard
              title="IP Restriction & granular access"
              subtitle="Restrict access by ensuring only users on a specific IP address can access your Marvel account"
              color="marvel"
              image={assets.logoGlobe}
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanL={1}>
            <SecurityCard
              title="99.98% Uptime SLA"
              subtitle="Our distributed infrastructure means you get the best and most reliable experience possible"
              color="purple--l"
              image={assets.logoArrow}
              raised
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanL={1}>
            <SecurityCard
              title="EU Hosted Infrastructure"
              subtitle="Our data center maintains multiple certifications including SOC1, SOC 2, SOC 3, ISO27001"
              color="teal"
              image={assets.logoMap}
            />
          </GridItem>
        </Grid>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/SecuritySection/index.js